"use strict";
/**
 * @jsx h
 * @jsxFrag Fragment
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
require("./styles.css");
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var initialA = "{\"format\":\"example\",\"content\":[{\"align\":\"center\",\"depth\":0,\"list\":false,\"content\":[{\"style\":{\"underline\":1,\"bold\":2,\"size\":20,\"italic\":2,\"color\":\"FFFFFF\",\"fontFamily\":\"Arial\"},\"content\":\"And please, feel free to send us your feedback and comments to \"},{\"style\":{\"underline\":1,\"bold\":2,\"size\":20,\"italic\":2,\"color\":\"4DC3FF\",\"fontFamily\":\"Arial\"},\"content\":\"hello world\"},{\"style\":{\"underline\":1,\"bold\":2,\"size\":20,\"italic\":2,\"color\":\"FFFFFF\",\"fontFamily\":\"Arial\"},\"content\":\", or just by clicking on the \"},{\"style\":{\"underline\":1,\"bold\":2,\"size\":20,\"italic\":2,\"color\":\"4DC3FF\",\"fontFamily\":\"Arial\"},\"content\":\"feedback\"}],\"ordered\":false}],\"version\":3}";
var initialB = "{\"format\":\"example\",\"version\":3.1,\"content\":[{\"list\":false,\"depth\":0,\"ordered\":false,\"content\":[{\"content\":\"And please, feel free to send us your feedback and comments to \",\"style\":{\"size\":20,\"color\":\"FFFFFF\",\"name\":\"Arial\",\"bold\":2,\"italic\":2,\"underline\":2}},{\"content\":\"foo\",\"style\":{\"size\":20,\"color\":\"4DC2FF\",\"name\":\"Arial\",\"bold\":2,\"italic\":2,\"underline\":2}},{\"content\":\", or just by clicking on the \",\"style\":{\"size\":20,\"color\":\"FFFFFF\",\"name\":\"Arial\",\"bold\":2,\"italic\":2,\"underline\":2}},{\"content\":\"feedback\",\"style\":{\"size\":20,\"color\":\"4DC2FF\",\"name\":\"Arial\",\"bold\":2,\"italic\":2,\"underline\":2}},{\"content\":\" button up above.\",\"style\":{\"size\":20,\"color\":\"FFFFFF\",\"name\":\"Arial\",\"bold\":2,\"italic\":2,\"underline\":2}}],\"align\":\"center\"}]}";
var MainUI = function () {
    var _a;
    var _b = (0, hooks_1.useState)({ a: initialA, b: initialB, options: {} }), input = _b[0], setInput = _b[1];
    var _c = (0, hooks_1.useState)({}), output = _c[0], setOutput = _c[1];
    var checkbox = function (field, label) {
        var _a;
        return ((0, preact_1.h)("div", null,
            (0, preact_1.h)("label", null,
                (0, preact_1.h)("input", { type: "checkbox", checked: !!((_a = input.options) === null || _a === void 0 ? void 0 : _a[field]), onChange: function () {
                        var _a;
                        var _b;
                        setInput((0, tslib_1.__assign)((0, tslib_1.__assign)({}, input), { options: (0, tslib_1.__assign)((0, tslib_1.__assign)({}, input.options), (_a = {}, _a[field] = !((_b = input.options) === null || _b === void 0 ? void 0 : _b[field]), _a)) }));
                    } }),
                (0, preact_1.h)("span", { className: "ml-2" }, label))));
    };
    var button = function (label, onClick) { return ((0, preact_1.h)("button", { onClick: onClick, type: "button", className: "px-10 py-2 bg-gray-100 hover:bg-gray-200 cursor-pointer" }, label)); };
    var outputBlock = function (label, innerHTML) { return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("div", null, label),
        (0, preact_1.h)("pre", { className: "bg-gray-100 border p-1 overflow-auto", dangerouslySetInnerHTML: { __html: innerHTML || "" } }))); };
    var inputBlock = function (value, onChange) { return ((0, preact_1.h)("textarea", { className: "p-1 w-full", rows: 12, value: value, onChange: function (e) {
            onChange(e.currentTarget.value);
        } })); };
    return ((0, preact_1.h)("div", { className: "p-4 space-y-2" },
        (0, preact_1.h)("h1", { className: "text-3xl break-all" }, "github.com/nsf/jsondiff"),
        (0, preact_1.h)("div", { className: "flex w-full flex-col space-y-2 space-x-0 sm:flex-row sm:space-x-2 sm:space-y-0" },
            inputBlock(input.a, function (a) { return setInput((0, tslib_1.__assign)((0, tslib_1.__assign)({}, input), { a: a })); }),
            inputBlock(input.b, function (b) { return setInput((0, tslib_1.__assign)((0, tslib_1.__assign)({}, input), { b: b })); })),
        (0, preact_1.h)("div", { className: "flex flex-wrap gap-2" },
            button("compare", function () { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
                var _a;
                return (0, tslib_1.__generator)(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = setOutput;
                            return [4 /*yield*/, jsonDiff(input)];
                        case 1:
                            _a.apply(void 0, [_b.sent()]);
                            return [2 /*return*/];
                    }
                });
            }); }),
            button("swap", function () {
                setInput((0, tslib_1.__assign)((0, tslib_1.__assign)({}, input), { a: input.b, b: input.a }));
            }),
            button("clear", function () {
                setInput((0, tslib_1.__assign)((0, tslib_1.__assign)({}, input), { a: "", b: "" }));
            })),
        checkbox("appendType", "append types"),
        checkbox("skipMatches", "skip matches"),
        ((_a = input.options) === null || _a === void 0 ? void 0 : _a.skipMatches) ? checkbox("suppressSkippedStrings", 'suppress "skipped" strings') : null,
        (output === null || output === void 0 ? void 0 : output.error) ? outputBlock("error", output.error) : null,
        (output === null || output === void 0 ? void 0 : output.status) ? outputBlock("status", output.status) : null,
        (output === null || output === void 0 ? void 0 : output.details) ? outputBlock("details", output.details) : null));
};
var go = new Go();
var inst = WebAssembly.instantiateStreaming(fetch("main.wasm"), go.importObject);
function jsonDiff(input) {
    return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
        var result;
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, inst];
                case 1:
                    result = _a.sent();
                    window.wasmInput = JSON.stringify(input);
                    return [4 /*yield*/, go.run(result.instance)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, JSON.parse(window.wasmOutput)];
            }
        });
    });
}
(function () { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var el;
    return (0, tslib_1.__generator)(this, function (_a) {
        el = document.createElement("div");
        document.body.appendChild(el);
        (0, preact_1.render)((0, preact_1.h)(MainUI, null), el);
        return [2 /*return*/];
    });
}); })();
